import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';

import { Salon } from '../../models/salon/salon.model';
import { UserService } from '../../services/user.service';
import { SalonService } from '../../services/salon.service';
import { Utilities } from '../../utilities/utilities';
import { AlertService } from '../../utilities/alert.service';
import { ToastService } from '../../utilities/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-site-settings',
  templateUrl: './site-settings.page.html',
  styleUrls: ['./site-settings.page.scss'],
})
export class SiteSettingsPage {

  public isLoading: boolean;

  public submitted: boolean;

  public savingInProgress: boolean;

  public salon: Salon;

  public siteSettingsForm: UntypedFormGroup;

  // public cancellationPolicy: FormControl;

  public analyticsCode: UntypedFormControl;

  public siteUrl: string;

  constructor (
             //private navCtrl: NavController,
              private userService: UserService,
              private formBuilder: UntypedFormBuilder,
              private readonly alertService: AlertService,
              private loadingCtrl: LoadingController,
              private readonly toastService: ToastService,
              private salonService: SalonService,
              private router: Router) {
    this.salon = userService.getSalon();
    this.isLoading = false;
    this.submitted = false;
    this.savingInProgress = false;
    // this.cancellationPolicy = new FormControl(this.salon.getCancellationPolicy(), Validators.maxLength(100));
    this.analyticsCode = new UntypedFormControl(this.salon.getAnalytics());
    this.siteSettingsForm = this.formBuilder.group({
      // cancellationPolicy: this.cancellationPolicy,
      analyticsCode: this.analyticsCode
    });

    if (this.userService.isLoggedIn() && this.userService.getSalon()) {
      const salonSubDomain = this.userService.getSalon().getSubDomain();
      if (salonSubDomain &&salonSubDomain.length > 0) {
        this.siteUrl = `https://${salonSubDomain}.salonmonster.com`;
      }
    }
  }



  public async onSiteSettingsSave () {
    this.submitted = true;

    if (this.siteSettingsForm.valid === false) {
      return;
    }

    // this.salon = this.salon.setCancellationPolicy(this.cancellationPolicy.value);
    this.salon = this.salon.setAnalytics(this.analyticsCode.value);    
    this.savingInProgress = true;

        const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
    this.salonService.saveSalon(this.salon)
    .subscribe({
      next: (result) => {
          loader.dismiss().then(() => {
            this.savingInProgress = false;
            this.submitted = false;
            this.userService.setSalon(this.salon);
            this.toastService.presentSimpleToast(`Your site settings have been successfully updated.`, 3000);
            //this.navCtrl.pop();
            this.router.navigateByUrl('settings');
          });
        },
        error: (e) => {
          loader.dismiss().then(() => {
            this.savingInProgress = false;
            this.alertService.presentErrorAlert();
          });
        }
    });
  }

}
